import React, { Component } from 'react';
import { images } from '../../../../settings';
import { BrowserRouter as Router, Link } from 'react-router-dom';

import './Tributacao.scoped.scss';

class Tributacao extends Component {
  constructor(props) {
    super(props);
    this.images = images;
  }
  render() {
    return (
      <div className="planos-template tributacao">
        <div className="planos-template--risca" style={{ backgroundColor: this.props.cor }}></div>
        <div className="planos-template__conteudo">
          {/* <h3 className="h2 h2--500 planos-template__titulo" style={{ color: this.props.cor }}>
            Liquidez
          </h3> */}
          <h4 className="planos-template__subtitulo">
            As iniciativas relacionadas à tributação se deram em duas frentes:
          </h4>
          <div className="planos-template__linha">
            <div className="tributacao planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_tributacao1} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Agenda tática: interlocução com a Receita Federal</h5>
                <p>
                  Foram endereçados diversos assuntos por meio da IMK. As sugestões foram voltadas para aprimoramento na
                  tributação de fundos imobiliários, FIPs, hedge cambial, operações em bolsa e investidores não
                  residentes.
                </p>
              </div>
            </div>
          </div>

          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_tributacao2} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">
                  Agenda de proteção: atuação direta em propostas tributárias do Executivo ou Legislativo
                </h5>
                <p>
                  Foi dada especial atenção à proposta do governo para criação da CBS (Contribuição Social sobre
                  Operações com Bens e Serviços) que substituiria PIS e Cofins. Também acompanhamos a discussão sobre a
                  Lei Complementar 175, que estabelece a cobrança do ISS (Imposto sobre Serviço) dos fundos no local do
                  tomador do serviço, entendido pela norma como sendo o cotista. Iniciamos, em conjunto com a CNF
                  (Confederação Nacional das Instituições Financeiras), o desenvolvimento de um sistema para centralizar
                  a coleta desses tributos e auxiliar as instituições financeiras.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="planos-template__footer">
          <a
            className="button button--aylen button--green button--border-medium button--size-m button--round-l button--text-thick"
            href="https://www.anbima.com.br/data/files/B5/B5/1F/15/375FE610DC784BE6192BA2A8/Relatorio_de_Iniciativas_2019.pdf "
            target="_blank"
          >
            Saiba mais no Relatório de Iniciativas
          </a>
        </div> */}
      </div>
    );
  }
}
export { Tributacao };
